export default __webpack_public_path__ + "static/media/fl-40px-3f3e3c.78f6cbc3.svg";